import { injectable } from "inversify";
import * as moment from 'moment';
import "moment-timezone";

import { ObjectUtils } from "../utils/object";

@injectable()
export class FormatService {
	public toString(format: ControlFormat, value: any, ...args: any[]): string {
		if (format && value != null) {
			let date: moment.Moment;
			let momentFormat: string;
			switch (format) {
				case "small-date":
					momentFormat = "DD/MM/YY";
					date = this.getMoment(value, args[0]);
					break;
				case "small-date-time":
					momentFormat = "DD/MM/YY HH:mm";
					date = this.getMoment(value, args[0]);
					break;
				case "small-full-date-time":
					momentFormat = "DD/MM/YY HH:mm:ss";
					date = this.getMoment(value, args[0]);
					break;
				case "short-date":
					momentFormat = "ll";
					date = this.getMoment(value, args[0]);
					break;
				case "date":
					momentFormat = "LL";
					date = this.getMoment(value, args[0]);
					break;
				case "date-time":
					momentFormat = "LLL";
					date = this.getMoment(value, args[0]);
					break;
				case "long-date-time":
					momentFormat = "LLLL";
					date = this.getMoment(value, args[0]);
					break;
				case "small-time":
					momentFormat = "LT";
					date = this.getMoment(value, args[0]);
					break;
				case "time":
					momentFormat = "LTS";
					date = this.getMoment(value, args[0]);
					break;
				case 'percent':
				case 'percent-full':
					const valueString = ObjectUtils.round(value * 100).toString();
					return format === "percent"
						? valueString
						: valueString + '%';
				case 'currency':
					return args[0].replace('{0}', value);
			}
			return date.format(momentFormat);
		}
		if (value != null && !isNaN(parseFloat(value as string))) {
			return (value as number).toString();
		}
		return value as string || "";
	}

	public parseDate(format: ControlFormat, value: string): Date {
		return new Date(value);
	}

	private getMoment(value, args) {
		let date;
		if (args) {
			if (args === "tz") {
				date = moment.tz(value, "Europe/London");
			} else {
				date = moment.utc(value);
			}
		} else {
			date = moment(value);
		}
		return date;
	}
}



// WEBPACK FOOTER //
// ./src/core/services/format.service.ts